import { Link } from 'react-router';
import { formatDate, formatInr } from '@mys/contracts/format';
import {
  INVOICE_STATUS_LABELS,
  INVOICE_TYPE_LABELS,
  outstandingInr,
  useCarePlans,
  useInvoices,
} from '../lib/portal.js';

/* ============================================================================
   /invoices — what has been billed, and what is still owed.
   ----------------------------------------------------------------------------
   The outstanding total is at the top because it is the only number anyone
   opens this screen for. It counts `due` invoices only: a refunded invoice is
   not a debt, and adding it in would have someone ringing up about money they
   do not owe.
   ========================================================================== */

export function InvoicesPage() {
  const invoices = useInvoices();
  const carePlans = useCarePlans();

  if (invoices.isPending) return <p className="muted">Load ho raha hai…</p>;

  if (invoices.error) {
    return (
      <p className="alert" role="alert">
        Bills abhi load nahi ho paye. Thodi der baad dobara kholiye.
      </p>
    );
  }

  const items = invoices.data?.invoices ?? [];
  const due = outstandingInr(items);
  const activePlan = (carePlans.data?.carePlans ?? []).find((plan) => plan.status === 'active');

  return (
    <>
      <h1 className="h1">Bills</h1>

      <section className="card">
        <p className="kicker">Bakaya</p>
        <p className="big">{formatInr(due)}</p>
        {due === 0 ? <p className="muted">Sab clear hai. Dhanyavaad.</p> : null}
      </section>

      {activePlan ? (
        <section className="card">
          <p className="kicker">Care plan</p>
          <p>
            {formatInr(activePlan.monthlyInr)} har mahine
            {activePlan.nextBillingAt ? ` · agla ${formatDate(activePlan.nextBillingAt)}` : ''}
          </p>
        </section>
      ) : null}

      {items.length === 0 ? (
        <p className="muted">Abhi koi bill nahi bana.</p>
      ) : (
        <ul className="list">
          {items.map((invoice) => (
            <li key={invoice.id}>
              <Link to={`/invoices/${invoice.id}`} className="list__row">
                <span>
                  <strong>{invoice.number}</strong>
                  <span className="muted small">
                    {' '}
                    · {INVOICE_TYPE_LABELS[invoice.type] ?? invoice.type}
                  </span>
                  <br />
                  <span className="muted small">{formatDate(invoice.createdAt)}</span>
                </span>
                <span className="list__end">
                  <strong>{formatInr(invoice.grossInr)}</strong>
                  <br />
                  <span className={invoice.status === 'due' ? 'pill pill--due' : 'pill'}>
                    {INVOICE_STATUS_LABELS[invoice.status] ?? invoice.status}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
